module.exports = __webpack_public_path__ + "static/img/bg13.df06b11a.png";